import configurationPost from "../config/configurationPost"
import connectionConfig from "../config/settings"
import dateNow from "../utility/dateNow";

//---------------------------------------------
//servicio para agregar una nueva notificación  
//---------------------------------------------
const date = dateNow();
const insertNotification = async (descripNotification, 
                                 seedId, 
                                 userId,
                                 notificationsTypeId, 
                                 CompOrigin) => {
    var post_values = {
        descripNotification : descripNotification,  
        seedId : seedId, 
        userId : userId, 
        dateNotification : date,
        notificationTypeId : notificationsTypeId
     }
    configurationPost.body = JSON.stringify(post_values)
    await fetch(connectionConfig.apiUrl+'/insertNotification/', configurationPost)
    .then(response => response.json())
    .then(response => {
        if(CompOrigin === 'AddSeed'){
           pushNotificationSeed(userId, seedId)
        }
    console.log('regresa -> /insertNotification/', response)
    })
    .catch(err =>{
    console.log(':( review internet service -> /insertNotification/', err )
    })
 }
 
//------------------------------------------------------
//Hace una push despues de generar una semilla para las push
//------------------------------------------------------
const pushNotificationSeed = async (userId,seedId) => {
    var post_values = {
      userId : userId,
      seedId :seedId
     }
    configurationPost.body = JSON.stringify(post_values)
    await fetch(connectionConfig.apiUrl+'/pushNotificationSeed/', configurationPost)
    .then(response => response.json())
    .then(response => {
    })
    .catch(err =>{
    console.log(':( review internet service /expoPushNotification/', err )
    })
 }

//-------------------------------------------------------------
//  Servicio que borra la notificacion del like si ya existe 
//-------------------------------------------------------------
    const deleteLikeNofication = async (seedId, userId, notificationTypeId) => {
        var post_values = {
            seedId: seedId,
            userId: userId,
            notificationTypeId : notificationTypeId
        }
        configurationPost.body = JSON.stringify(post_values)
        await fetch(connectionConfig.apiUrl + '/deleteLikeNotification/', configurationPost)
            .then(response => response.json())
            .then(response => {
                console.log('regresa /deleteLikeNotification/', response.data)
            })
            .catch(err => {
                console.log(':( review internet service /deleteLikeNotification/', err)
            })
    }

 export default {
     insertNotification,
     pushNotificationSeed,
     deleteLikeNofication 
}